import React from "react";
import { MapPin, Briefcase } from "lucide-react";
import { Card, Image } from "antd";
import { Tag } from "antd";
import { useNavigate } from "react-router-dom";
import config from "@/config";

const IndustrialParkCard = ({ data }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(config.routes.IndustrialPack + `/${data.CodeKcn}`);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <Card
      onClick={handleClick}
      hoverable
      cover={
        <Image
          alt={"BANNER"}
          src={config.ImageConfig.getBanner(data.Banner)}
          className="w-full max-h-[250px] min-h-[250px]"
          preview={false}
        />
      }
      className="w-full overflow-hidden transition-all duration-300 border-2 p-2 hover:border-primary hover:shadow-lg"
    >
      <Card.Meta
        title={
          <h3 className="font-semibold text-lg sm:text-md md:text-lg mb-2 truncate">
            {data.NameKcn}
          </h3>
        }
        description={
          <div className="flex flex-col sm:flex-row items-start sm:items-center space-x-0 sm:space-x-2 sm:space-y-0 space-y-2">
            <Tag className=" bg-secondary-bg text-secondary flex items-center space-x-1 px-2 py-1 rounded-xl">
              <MapPin className="w-4 h-4" />
              <span>
                <strong>Miền</strong> {data.NameKhuVuc} - <strong>Tỉnh </strong>{data.NameTinh}
              </span>
            </Tag>
            <Tag className=" bg-primary-bg text-primary flex items-center space-x-1 px-2 py-1 rounded-xl">
              <Briefcase className="w-4 h-4" />
              <span>Có {data.JobCount} việc làm</span>
            </Tag>
          </div>
        }
      />
    </Card>
  );
};

export default IndustrialParkCard;
